function slideToggle(element, duration = 300) {
  if (window.getComputedStyle(element).display === 'none') {
    element.style.display = 'block';
    const height = element.scrollHeight;
    element.style.height = '0px';
    element.style.overflow = 'hidden';
    element.style.transition = `height ${duration}ms ease-in-out`;

    setTimeout(() => {
      element.style.height = `${height}px`;
    }, 10);

    setTimeout(() => {
      element.style.height = '';
      element.style.overflow = '';
    }, duration);
  } else {
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = 'hidden';
    element.style.transition = `height ${duration}ms ease-in-out`;

    setTimeout(() => {
      element.style.height = '0px';
    }, 10);

    setTimeout(() => {
      element.style.display = 'none';
      element.style.height = '';
      element.style.overflow = '';
    }, duration);
  }
}

function setReadMore(toggle) {
  const list = toggle.closest('.post__list');
  const moreContent = list?.querySelector('.post__more-content');

  if (!moreContent) return;

  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    slideToggle(moreContent);
    toggle.classList.toggle('is-open');
  });
}

document.querySelectorAll('.post__read-more').forEach(setReadMore);
